import { createContext, useContext } from "react";
import type { Tier } from "@/lib/tier";

export const TIER_OVERRIDE_STORAGE_KEY = "excerptus.tierOverride";
export const VALID_OVERRIDE_TIERS: Tier[] = ["starter", "plus", "pro", "elite", "agency"];

export type TierOverrideCtx = {
  override: Tier | null;
  setOverride: (tier: Tier | null) => void;
  clearOverride: () => void;
};

export const TierOverrideContext = createContext<TierOverrideCtx>({
  override: null,
  setOverride: () => {},
  clearOverride: () => {},
});

export const useTierOverride = () => useContext(TierOverrideContext);
